import Account from "@/helper/AccountHelper.js";
import Util from "@/helper/Utility.js";
import { mapState } from 'vuex';

export default {
    data: function () {
        return {
            isAccountLoaded: false,
            isLogin: false,
            user: {},
        };
    },
    computed: {
        ...mapState({
            profile: state => state.profile.profile,
            address: state => state.profile.address,
            shipping: state => state.profile.shipping,
            points: state => state.profile.data.updated_points,
        }),
    },
    created: function () {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.getAccountData();

            if (Util.isFunction(this.accountInitiated)) {
                this.accountInitiated();
            }
        }).finally(() => {
            this.isAccountLoaded = true;
        });
    },
    methods: {
        getToken: function () {
            return Account.getToken();
        },
        getAccountData: function () {
            this.user = Account.getCacheUser();
        },
        //point
        updateUserPoint: function (updatedPoint) {
            if (!updatedPoint) return;

            this.$store.commit("updatePoints", updatedPoint);
        },
        getPictureLine: function (){
            var userCache = Account.getCacheUser();
            if(userCache && userCache.line){
                this.isLine = true;
                this.linePicture = userCache.line.pictureUrl;
            }
            return this.linePicture;
        },

        // profile
        setProfile: function (profile) {
            this.$store.commit("setProfile", profile);

        },
        setProfileDispatch: function (profile) {
            this.$store.dispatch('setProfile', profile);
        },

        /**
         * @param {Number} point
         */
        updatePoint: function (point) {
            this.$store.commit("updatePoints", point);
        },
    }
}
